const RESTRICTED_TEXT_TAGS = ['strong', 'em', 'b', 'i', 'p', 'ul', 'ol', 'li'] as const;
export const RESTRICTED_TAGS = ['br', 'a', ...RESTRICTED_TEXT_TAGS] as const;
export const RESTRICTED_ATTRS = ['href'] as const;
export const ALLOWED_IFRAME_ATTRS = ['src', 'scrolling', 'frameborder', 'allowfullscreen', 'width', 'height'] as const;
